import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import BackButton from '@ts-core/components/BackButton';
import PageContentLayout from '@ts-core/core/components/PageContentLayout';
import ActivityAnswer from '@ts-core/modules/activities/components/ActivityAnswer';
import ActivityResult from '@ts-core/modules/activities/components/ActivityResult';
import ActivityBaseMessage from '@ts-core/modules/activities/components/ActivityBaseMessage';

import DoActivityForm from '../../components/DoActivityForm';

import { useActivity, useActivityActions } from '../../hooks';

interface ActivityPageRouteParams {
  courseId: string;
  activityId: string;
}

const ActivityPage = () => {
  const { courseId, activityId } = useParams<ActivityPageRouteParams>();

  const { loading, activity } = useActivity({ courseId, activityId });
  const answer = activity?.answer;

  const { file, onFileSelected, onTextAnswerChanged, textAnswer, onAnswerActivity, answerActivityLoading, answerActivityError, onDeleteAnswer } =
    useActivityActions({
      courseId,
      activityId,
    });

  const handleDeleteAnswer = useCallback(() => {
    if (activity && onDeleteAnswer) {
      onDeleteAnswer(activity);
    }
  }, [onDeleteAnswer, activity]);

  const messageBoxWidth = {
    xs: '85%',
    sm: '70%',
    md: '60%',
  };
  return (
    <Box>
      <BackButton title={activity?.name} subtitle="Tareas" href={`/${courseId}/activities`} />
      <PageContentLayout>
        <Stack spacing={2}>
          <Box display="flex" justifyContent="flex-start">
            <ActivityBaseMessage
              mode="professor"
              sx={{ width: messageBoxWidth }}
              title={activity?.createdBy?.name}
              text={activity?.statement}
              loading={loading}
            />
          </Box>

          {activity && !activity.answered && !activity.expired && (
            <Box width="100%">
              <DoActivityForm
                activity={activity}
                loading={loading}
                onFileSelected={onFileSelected}
                file={file}
                onTextAnswerChanged={onTextAnswerChanged}
                textAnswer={textAnswer}
                onAnswerActivity={onAnswerActivity}
                answerActivityLoading={answerActivityLoading}
                answerActivityError={answerActivityError}
              />
            </Box>
          )}
          {!!activity?.answered && (
            <Box display="flex" justifyContent="flex-end">
              <ActivityAnswer
                title="Yo"
                sx={{ width: messageBoxWidth }}
                answer={answer}
                onDeleteAnswer={!answer?.gradedAt ? handleDeleteAnswer : undefined}
              />
            </Box>
          )}
          {!!answer?.gradedAt && (
            <Box display="flex" justifyContent="flex-start">
              <ActivityResult sx={{ width: messageBoxWidth }} answer={answer} loading={loading} />
            </Box>
          )}
        </Stack>
      </PageContentLayout>
    </Box>
  );
};

export default ActivityPage;
